import axios from 'axios';
import config from '../config';
import moment from 'moment';
import {JsonHeaders} from '../constants';

export default {
    getRelay(id) {
        return axios.get(config.publicPath + 'pmta_relays/' + id, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    getRelays(filter) {
        let parameters = {
            _page: filter.page,
            itemsPerPage: filter.perPage,
            smtpHost: filter.smtpHost,
            description: filter.description,
            "user.id": filter.userId,
            "group.id": filter.groupId,
            id: filter.relayId,
            "pmtaServer.id": filter.serverId
        };
        if (filter.isVps !== null) {
            parameters['pmtaServer.isVps'] = filter.isVps;
        }
        parameters['order[' + filter.orderBy + ']'] = filter.orderDirection;
        return axios.get(config.publicPath + 'pmta_relays', {
            params: parameters,
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    getRelaysByGroup(groupId) {
        let parameters = {
            "group.id": groupId,
            'pagination': false
        };
        return axios.get(config.publicPath + 'pmta_relays', {
            params: parameters,
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    createRelay(formData) {
        return axios.post(config.publicPath + 'pmta_relays', formData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    updateRelay(id, formData) {
        return axios.put(config.publicPath + 'pmta_relays/' + id, formData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    deleteRelay(id) {
        return axios.delete(config.publicPath + 'pmta_relays/' + id, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    uploadRelays(data) {
        return axios.post(config.publicPath + 'upload_pmta_relays', data, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            },
        });
    },
    getRelayDkim(id) {
        return axios.get(config.publicPath + 'pmta_relays/' + id + '/get_dkim', {
            headers: JsonHeaders
        }).then(response => {
            response.text = response.data.dkim;
            return response;
        }).catch(error => {
            error.response.text = 'Error: ' + error.response.data.error[0];
            return error.response
        });
    },
    generateRelayDkim(id) {
        return axios.get(config.publicPath + 'pmta_relays/' + id + '/gen_dkim', {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    deleteRelayDkim(id) {
        return axios.get(config.publicPath + 'pmta_relays/' + id + '/del_dkim', {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    getRelayVmtaDate(id) {
        return axios.get(config.publicPath + 'pmta_relays/' + id + '/vmta_config_date', {
            headers: JsonHeaders
        }).then(response => {
            response.text = moment.utc(response.data.date.toString()).format('D/M/YYYY H:mm');
            return response;
        }).catch(error => {
            error.response.text = 'Error: ' + error.response.data.error[0];
            return error.response
        });
    },
    uploadRelayVmta(id) {
        return axios.get(config.publicPath + 'pmta_relays/' + id + '/upload_vmta', {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    deleteRelayVmta(id) {
        return axios.get(config.publicPath + 'pmta_relays/' + id + '/delete_vmta', {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    getRelayReputations(id) {
        return axios.get(config.publicPath + 'pmta_relays/' + id, {
            params: {'groups[]': 'relay_reputations'},
            headers: JsonHeaders
        }).catch(error => {
            error.response.text = 'Error: ' + error.response.data.error[0];
            return error.response
        });
    },
    bulkMove(relays, group) {
        let data = {relaysIds: relays, groupId: group};
        return axios.post(config.publicPath + 'pmta_relays/bulk_move', JSON.stringify(data), {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    bulkActivity(relays, activity) {
        let data = {relaysIds: relays, activity: activity};
        return axios.post(config.publicPath + 'pmta_relays/bulk_activity', JSON.stringify(data), {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    bulkDelete(relays) {
        let data = {relaysIds: relays};
        return axios.post(config.publicPath + 'pmta_relays/bulk_delete', JSON.stringify(data), {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    getPoorRelaysCount(filter) {
        let parameters = {
            hostname: filter.smtpHost,
            description: filter.description,
            "userId": filter.userId,
            "pmtaRelayGroupId": filter.groupId,
            "pmtaServerId": filter.serverId,
            id: filter.relayId,
            isVps: filter.isVps
        };

        return axios.post(config.publicPath + 'pmta_relays/count_poor', JSON.stringify(parameters), {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    editDescription(relayId, description) {
        let queryData = new FormData();
        queryData.append('relayType', JSON.stringify(1));
        queryData.append('relayId', JSON.stringify(relayId));
        queryData.append('description', JSON.stringify(description));
        return axios.post(config.publicPath + 'relays/edit_description', queryData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    getRelayBounceStats(relayId, filter) {
        return axios.get(config.publicPath + 'relay_bounce_stats/pmta', {
            headers: JsonHeaders,
            params: {
                relayId: relayId,
                providerId: filter.mailProvider,
                fromDate: filter.fromDate,
                toDate: filter.toDate,
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    }
}